// types
import { ClaimDetailsGroupsEnum } from 'features/claims/types'

export const claimsTableInitialState = {
  totalItems: 0,
  itemsPerPage: 100,
  page: 1,
  sorting: [],
  filters: {},
  statusFilter: 'needsWork',
  rows: null,
  count: 0,
  selectedRow: [],
}

export const allClaimRouteUrl = {
  batchId: undefined,
  batchCode: undefined,
}

export const claimEntitiesDetails: { [k in ClaimDetailsGroupsEnum]: string[] } = {
  [ClaimDetailsGroupsEnum.provider]: [
    'biller_name',
    'visit_id',
    'claim_submission_date',
    'callInformation_taxId',
    'rendering_provider',
    'rendering_provider_npi',
    'biller_npi',
    'ptan',
    'date_of_provision_or_admission',
    'discharge_date',
    'claim_billed_amount',
    'provider_street1',
    'provider_street2',
    'provider_city',
    'provider_state',
    'provider_zip_code',
  ],
  [ClaimDetailsGroupsEnum.patient]: [
    'patient_first_name',
    'patient_last_name',
    'patient_id',
    'patient_dob',
    'patient_sex',
    'patient_street1',
    'patient_street2',
    'patient_city',
    'patient_state',
    'patient_zip',
  ],
  [ClaimDetailsGroupsEnum.claim]: [
    'insurer_claim_id',
    'claim_submission_date',
    'claim_billed_amount',
    //'claim_processed_date',
    //'claim_allowed_amount',
    //'claim_applied_to_deductible',
    //'claim_member_responsible_amount',
    //'claim_remittance_advice_date',
    //'claim_payment_eft_number',
    //'claim_payment_date',
    //'claim_payment_check_number',
    //'payer_claim_service_date',
    //'payer_claim_received_date',
    'outstanding_balance',
  ],
  [ClaimDetailsGroupsEnum.insurer]: [
    'member_id',
    'insurer_name',
    'insurer_plan_name',
    'insurer_id',
    'insurer_claim_id',
    'group_id',
    'insurer_phone_number',
  ],
}
